"use client";

import Link from "next/link";
import { useActionState } from "react";
import { useFormStatus } from "react-dom";
import { requestPasswordReset, type AuthFormState } from "@/lib/auth/actions";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

function SubmitButton() {
  const { pending } = useFormStatus();
  return (
    <Button type="submit" size="lg" className="h-11 w-full text-base" disabled={pending}>
      {pending ? "Надсилаємо…" : "Надіслати посилання"}
    </Button>
  );
}

export function ForgotPasswordForm() {
  const [state, action] = useActionState<AuthFormState, FormData>(
    requestPasswordReset,
    undefined
  );

  return (
    <form action={action} className="flex flex-col gap-5" noValidate>
      <div className="flex flex-col gap-2">
        <Label htmlFor="email">Email облікового запису</Label>
        <Input
          id="email"
          name="email"
          type="email"
          inputMode="email"
          autoComplete="email"
          required
          className="h-11 text-base"
          aria-invalid={state?.status === "error" && state.field === "email" || undefined}
        />
      </div>
      {state ? (
        <p
          role={state.status === "error" ? "alert" : "status"}
          className={state.status === "error" ? "text-sm text-destructive" : "rounded-lg bg-accent p-3 text-sm text-accent-foreground"}
        >
          {state.status === "error" ? state.error : state.message}
        </p>
      ) : null}
      <SubmitButton />
      <Button asChild variant="ghost" className="h-11">
        <Link href="/login">Повернутися до входу</Link>
      </Button>
    </form>
  );
}
